import React from "react";
import "./Statistics.css";
import {
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
} from "recharts";
import { useLoaderData } from "react-router-dom";

const Statistics = () => {
  const courseData = useLoaderData();
  const courses = courseData.data;
  console.log(courses);
  return (
    <div className="row d-flex justify-content-center">
      <div className="col-10">
        <h3 className="mb-5 text-primary text-center mt-5">
          Area Chart(Name vs Total Question)
        </h3>
        <div className="d-flex justify-content-center">
          <AreaChart
            width={730}
            height={250}
            data={courses}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="total"
              stroke="#8884d8"
              fillOpacity={1}
              fill="url(#colorUv)"
            />
          </AreaChart>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
